import { render, staticRenderFns } from "./InsertTokenInstructions.partial.vue?vue&type=template&id=6873deaa&scoped=true"
import script from "./InsertTokenInstructions.partial.vue?vue&type=script&lang=js"
export * from "./InsertTokenInstructions.partial.vue?vue&type=script&lang=js"
import style0 from "./InsertTokenInstructions.partial.vue?vue&type=style&index=0&id=6873deaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6873deaa",
  null
  
)

export default component.exports